import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataUtils } from 'app/core/util/data-util.service';
import { Component, OnInit } from '@angular/core';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'cbic-whats-new',
  templateUrl: './whats-new.component.html', 
  styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewComponent implements OnInit {
  translateService: any;
  renderer: any;
  contentTypeId:any;
  whatsNewData:any;
  whatsNewDataNotFound=false;
  currentPage:any;
  whatsNewDataList:any;
 
  first_page:any;
  last_page:any;
  next_page:any;
  next_size:any;
  prev_page:any;
  prev_size:any;
  usedLanguage:any
  totalRecords = 14;
  ngbPaginationPage = 1;
  showRecordSelected = 6;
  PdfDataList:any;
  color:any;
  constructor(private sessionStorageService: SessionStorageService,private contentMstService : CbicContentMstService,private cbicContentTypeMstService :CbicContentTypeMstService,private changeLnService: ChangeLanguageService, private cbicDocMstService: CbicDocMstService
    ,private http: HttpClient,  private dataUtils: DataUtils) { }

  ngOnInit(): void {
    this.usedLanguage = this.changeLnService.getLanguage();
  this.getContentId();
  //this.fetchListOfChildDoc();
  }



  getContentId() :void{
    this.cbicContentTypeMstService.getContentId('what-new').subscribe(
      (fullBody) => {
        
          this.contentTypeId = fullBody.body?.id;

          this.getWhatsNewData(this.contentTypeId);
          this.color = this.sessionStorageService.retrieve('colr');
        
      }
    )
  }

  getWhatsNewData(contentTypeId:any): void{


  const query: any = { page: 0, size: 6 };
  query['content_type_id'] = contentTypeId;
 this.first_page=0;
 this.last_page=6;
  this.contentMstService.getWhatsNewDataList(query)
      .subscribe(
        (res: HttpResponse<ICbicContentMst[]>) => {
          this.whatsNewData = res.body
          if (this.whatsNewData.length === 0) {
            this.whatsNewDataNotFound = true
          } else {
            this.setPageinationDtls();
            this.whatsNewDataNotFound = false;
            //alert(this.custNotFound)
            this.fetchListOfChildDoc(this.whatsNewData,contentTypeId);
          }
  });
    
  }

  setPageinationDtls():void{
    // this.currentPage = 1;
   // this.ngbPaginationPage = 1;
    this.showRecordSelected = 6;
  }

  
  next():void {
    
    //  count query 
        this.next_page=(Number(this.first_page)+6);
        this.next_size=6;

        // alert(this.next_page);
       // alert(this.next_size);

        const query1: any = { };
        query1['page'] = this.next_page;
        query1['size'] = this.next_size;
        query1['content_type_id'] = this.contentTypeId;

          //alert(this.contentTypeId);
          this.contentMstService.getWhatsNewDataList(query1)
            .subscribe(
              (res1: HttpResponse<ICbicContentMst[]>) => {
                //this.whatsNewData = res.body
                
                if (res1.body?.length !== 0) {

                // alert(this.contentTypeId);
            
                  this.first_page=this.next_page;
                  this.last_page=this.next_size;

                  const query: any = { };
                  query['page'] = this.first_page;
                  query['size'] = this.last_page;
                  query['content_type_id'] = this.contentTypeId;
                  
                //alert(this.contentTypeId);
                  this.contentMstService.getWhatsNewDataList(query)
                      .subscribe(
                        (res: HttpResponse<ICbicContentMst[]>) => {
                          this.whatsNewData = res.body
                          if (this.whatsNewData.length === 0) {
                            this.whatsNewDataNotFound = true
                          } else {
                            this.setPageinationDtls();
                            this.whatsNewDataNotFound = false;
                            //alert(this.custNotFound)
                            this.fetchListOfChildDoc(this.whatsNewData,this.contentTypeId);
                          }
                  });
                }
              
              
          });


    
}
prev():void{
    //alert( this.first_page)
   // alert( this.last_page)
      if(Number(this.first_page)>0){
              this.prev_size=6;

              this.prev_page= this.first_page-6;
    

                this.first_page=this.prev_page;
                this.last_page=this.prev_size;

               /*  if(Number(this.first_page)===1)
                {
                  this.first_page=0;
                } */
                //alert( this.first_page)
                //alert( this.last_page)
              const query: any = {};
              query['page'] = this.first_page;
              query['size'] = this.last_page;
              query['content_type_id'] = this.contentTypeId;

              this.contentMstService.getWhatsNewDataList(query)
                  .subscribe(
                    (res: HttpResponse<ICbicContentMst[]>) => {
                      this.whatsNewData = res.body
                      if (this.whatsNewData.length === 0) {
                        this.whatsNewDataNotFound = true
                      } else {
                        this.setPageinationDtls();
                        this.whatsNewDataNotFound = false;
                        //alert(this.custNotFound)
                        this.fetchListOfChildDoc(this.whatsNewData,this.contentTypeId);
                      }
              });
                
        }
  }

  loadPage(page?: number, dontNavigate?: boolean): void {
    this.currentPage=page;
    const pageToLoad: number = page ?? this.currentPage ?? 1;

    const query: any = { };
    query['page'] =(pageToLoad - 1)*6;
    query['size'] = this.showRecordSelected;
    query['content_type_id'] = this.contentTypeId;

    this.first_page=(pageToLoad - 1)*6;
    this.last_page=this.showRecordSelected;
    alert(this.first_page);
    alert(this.last_page);
    alert(this.contentTypeId);
    this.contentMstService.getWhatsNewDataList(query)
        .subscribe(
          (res: HttpResponse<ICbicContentMst[]>) => {
            this.whatsNewData = res.body
            if (this.whatsNewData.length === 0) {
              this.whatsNewDataNotFound = true
            } else {
              this.setPageinationDtls();
              this.whatsNewDataNotFound = false;
              //alert(this.custNotFound)
              this.fetchListOfChildDoc(this.whatsNewData,this.contentTypeId);
            }
    });


  }
/* 
  ViewWhatsNew(lan?: any, id?: any): void {
    alert("langauge");
    alert(lan);
    alert("Id");
    alert(id);

  } */

  /* fetchListOfChildDoc(): void {
    this.cbicDocMstService.getFileallDoc().subscribe(
      (data: HttpResponse<ICbicDocMst[] >) => {
        if (data.body) {
          this.PdfDataList = data.body;
        }

      })
    } */
    fetchListOfChildDoc(whatsNewData:any,contentTypeId:any): void {

      // get primary list id 
  
      if (this.whatsNewData) {
        this.whatsNewDataList = [];
      
        for (let i = 0; i < this.whatsNewData.length; i++) {
          
          this.whatsNewDataList[i] = Number(this.whatsNewData[i].id) ;
  
           /*  const mainId = { 'Pid': this.whatsNewData[i].id}
            this.whatsNewDataList.push(mainId); */
         
          }
         // alert("Doc id list: ");
        //  alert(this.whatsNewDataList);
      
      }
  
      // end here part
      
    this.cbicDocMstService.getDocList(this.whatsNewDataList,contentTypeId).subscribe(
        (data: HttpResponse<ICbicDocMst[] >) => {
          if (data.body) {
            this.PdfDataList = data.body;
          }
  
        })
      }

    ViewPdf(path1: any): void {
      //alert(path1);
      
     // alert(arr1[arr1.length - 2]);
      if (path1) {
        const arr1 = path1.split('//');
        if(arr1 !== undefined && ((arr1[arr1.length - 2]) === 'https:' || (arr1[arr1.length - 2]) === 'http:')){
          window.open(path1, "_blank");
        }else{
        const arr = path1.split('.');
        if ((arr[arr.length - 1] === 'pdf') || (arr[arr.length - 1] === 'PDF')) {
          this.http.get("content/pdf/" + String(path1), { responseType: 'text' })
            .subscribe((res2) => {
              if (res2) {
                const json = JSON.parse(res2);
                const fileURL = 'data:application/pdf;base64,' + String(json.data);
                this.dataUtils.openFile(String(json.data), "application/pdf");
              }
              else {
                alert("No data found");
              }
            }
            );
        }
        else {
          if (confirm("No preview available press ok for download the file")) {
            alert("download file successfully");
          }
        }
      }
      }
      else { alert("No data found"); }
    }
}
